<svelte:options tag='swc-secondary-button' immutable={true} />

<script>

  import { get_current_component } from 'svelte/internal';
  import { initEventDispatcher } from '../helpers/init-event-dispatcher';

  export let text = '';

  const dispatch = initEventDispatcher(get_current_component());
  const onPress = (newValue) => dispatch('press', newValue);

</script>

<style>
  button {
    background: #FFFFFF;
    border-radius: 22px;
    border: 1px solid rgba(34,51,153,.5);
    color: #192277;
    font-size: 0.75em;
    letter-spacing: 1.33333px;
    text-transform: uppercase;
    padding: 13px 0 14px;
    max-width: 168px;
    width: 100%;
    margin: 0 auto;
    display: block;
    font-family: inherit;
    font-weight: 600;
    cursor: pointer;
    user-select: none;
  }
  button:hover {
    background: #192277;
    border-color: #192277;
    color: #FFFFFF;
  }
</style>

<button on:click={onPress}>{text}</button>
